import React from 'react';
import './Investment.css';
import {Row, Col} from 'antd';

const Investment = (props) => {
  return (
    <div class='investment-container'>
      <div class='investment-title-container'>
        <span class='investment-title'>
          What's my investment
        </span>
      </div>
      <Row>
        <Col xs={2} sm={2} lg={8}></Col>
        <Col xs={20} sm={20} lg={8}>
      <div class='investment-card-container'>
        <span class='green-design-gutter'/>
        <div class='investment-card'>
          <span id='one-time-payment'>
            ONE TIME PAYMENT
          </span>
          <span class='investment-card-amt-container'>
            <span class='discounted-amt'>
              <sup>₹ </sup>199
            </span>
            <strike>
              <span class='actual-amt'>
                ₹ 299
              </span>
            </strike>
          </span>
          <span class='investment-card-buy-container'>
            <button class='investment-card-buy-btn'>
              <span class='investment-card-buy-btn-txt'>
                {!props.isLoggedIn && 'Login'}
                {props.isLoggedIn && 'Buy Now'}
              </span>
            </button>
          </span>
        </div>
      </div>
        </Col>
        <Col xs={2} sm={2} lg={8}></Col>
      </Row>
    </div>
  )
}
export default Investment;
